//German translations
export default {
  'general.logout': 'Ausloggen',
  'general.sessionExpired':
    'Ihre Sitzung ist abgelaufen. Bitte erneut anmelden.',
  'general.error': 'Etwas ist schief gelaufen',
  'general.tryAgain': 'Bitte versuchen Sie es später noch einmal.',
  'general.login': 'Login',
  'login.welcome': 'Willkommen bei Piction.',
  'login.loginMessage': ' Bitte melden Sie sich an.',
  'general.reLogin': 'Bitte erneut anmelden.',
  'general.loginCode': 'Bitte den Authentifizierungs-Code eingeben',
  'general.language': 'Sprache',
  'general.language.english': 'Englisch',
  'general.language.french': 'Französisch',
  'general.language.german': 'Deutsch',
  'general.scrollToTop': 'Bitte nach oben scrollen',
  'general.fillMandatory': 'Bitte alle Pflichtwerte ausfüllen',
  'general.invalidEmail': 'Ungültige E-Mail-Adresse',
  'general.select': 'Auswählen',
  'general.cancel': 'Abbrechen',
  'general.add': 'Hinzufügen',
  'general.remove': 'Entfernen',
  'general.save': 'Speichern',
  'general.update': 'Aktualisieren',
  'general.close': 'Schließen',
  'general.download': 'Download',

  'login.invalidCode': '',
  'login.codeRegistryRequired':
    'Für Ihr Konto ist eine Zwei-Faktor-Authentifizierung erforderlich',
  'login.codeRegistryMsg': 'Bitte mit dem folgenden QR-Code registrieren',
  'login.codeDisplayOnceWarning':
    'Bitte beachten: Der QR-Code wird nur einmal angezeigt',
  'login.scanToLinkMsg':
    'Den QR-Code scannen, um Ihr Konto mit einer Zwei-Faktor-Authentifizierungs-App zu verknüpfen',
  'login.registerBtn': 'Registrieren',

  'searchResults.sortBy': 'Sortieren nach',
  'searchResults.sortByNone': 'Ohne Sortierung',
  'searchResults.sortManually': 'Medien manuell sortieren',
  'searchResults.noItemFound': 'Keine Elemente gefunden',

  'searchResults.filter': 'Filter',
  'searchResults.filter.date': 'Datum',
  'searchResults.filter.date.from': 'Von',
  'searchResults.filter.date.to': 'Bis',
  'searchResults.filter.date.all': 'Alle',
  'searchResults.filter.applyFiltersButton': 'Filter verwenden',

  'searchResults.options': 'Optionen',
  'searchResults.options.selection': 'Auswahl',
  'searchResults.options.selection.selectPage': 'Ganze Seite auswählen',
  'searchResults.options.selection.selectSearch': 'Alle Ergebnisse auswählen',
  'searchResults.options.selection.deselectAll': 'Auswahl löschen',
  'searchResults.options.selection.bulkEdit': 'Massenaktualisierung',
  'searchResults.options.actions': 'Aktionen',
  'searchResults.options.actionsWorkspaceTitle': 'Arbeitsplatzmaßnahmen',
  'searchResults.options.actions.addToWorkspace': 'Zum {workspaceName}',
  'searchResults.options.actions.addToWorkspace.default': 'Arbeitsbereich',
  'searchResults.options.actions.removeSelectedFromWorkspace':
    'Auswahl im Arbeitsbereich entfernen',
  'searchResults.options.actions.exportAllToExcel':
    '{selectCount, plural, =0 {Alle} other {Selected}} als Excel (Alle Datenfelder) exportieren',
  'searchResults.options.actions.exportTagsToExcel':
    '{selectCount, plural, =0 {Alle} other {Selected}} als Excel (Auswahl von Datenfeldern) exportieren',
  'searchResults.options.actions.exportToPPT':
    '{selectCount, plural, =0 {Alle} other {Selected}} als PPT exportieren',
  'searchResults.options.actions.exportToZip':
    '{selectCount, plural, =0 {Alle} other {Selected}} als ZIP exportieren',
  'searchResults.options.actions.exportToPDF':
    '{selectCount, plural, =0 {Alle} other {Selected}} als PDF exportieren',
  'searchResults.options.actions.batchDownload':
    'Alle Arbeitsbereich-Elemente herunterladen',
  'searchResults.options.actions.emailAll': 'E-Mail an alle',
  'searchResults.options.actions.relateAllInWorkspace':
    'Alle Elemente im Arbeitsbereich verknüpfen',
  'searchResults.options.actions.umosExpectedError':
    'Fehler beim Abrufen der Artikeldaten',
  'searchResults.options.actions.noUMOsSelected': 'Keine Elemente gefunden',
  'searchResults.options.actions.shareAsPortal': 'Als Portal teilen',
  'searchResults.options.actions.shareExternalPortal':
    'Als externes Portal teilen',
  'searchResults.options.actions.saveToDropbox':
    '{selectCount, plural, =0 {Alle} other {Selected}} in Dropbox speichern',
  'searchResults.options.actions.resize':
    'Größe ändern {selectCount, plural, =0 {Alle} other {Selected}}',
  'searchResults.options.actions.dropboxSaveSuccess':
    'Erfolg! Dateien in Ihrer Dropbox gespeichert',
  'searchResults.options.actions.dropboxSaveError':
    'Beim Speichern Ihrer Dateien in Dropbox ist ein Fehler aufgetreten',
  'searchResults.compare': 'Vergleichen',
  'searchResults.purge': 'Leeren',
  'searchResults.purgeConfirmationTitle': 'Leere Papierkorb',
  'searchResults.purgeConfirmMessage': 'Sind Sie sicher, dass Sie alle Elemente im Papierkorb dauerhaft löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.',
  'searchResults.purgeFailed': 'Beim Löschen des Papierkorbs ist ein Fehler aufgetreten',
  'searchResults.copy': 'Kopieren',
  'searchResults.copy-screen_overlay__message': 'Zielkategorie auswählen',
  'searchResults.copy-screen_overlay__cancel':
    'ESC drücken um Vorgang abzubrechen',
  'searchResults.download.tooManyItems': 'Unable to download more than {maxItems} items',
  'searchResults.download.selectAnyItem': 'Select items to download',

  'searchResults.loadingHeader': 'Wird geladen...',
  'searchResults.previousSearch': 'Zurück zu:',
  'searchResults.previousSearchAdv': 'Erweiterte Suche',
  'searchResults.objectsFoundHeader':
    '{objectsFoundCount} {objectsFoundCount, plural, one {Element} other {Elemente}} gefunden',
  'searchResults.objectSelected':
    '{objectsSelectedCount} {objectsSelectedCount, plural, one {Element} other {Elemente}} ausgewählt',

  'categoryDialog.editHeader': 'Kategorie bearbeiten',
  'categoryDialog.saveButton': 'Speichern',
  'categoryDialog.createChildHeader': 'Unterkategorie hinzufügen',
  'categoryDialog.createButton': 'Erstellen',
  'categoryDialog.addHeader': 'Kategorie hinzufügen',
  'categoryDialog.namePlaceholder': 'Kategorienamen eingeben',
  'categoryDialog.deleteCheckbox': 'Diese Kategorie löschen',
  'categoryDialog.deleteButton': 'Löschen',
  'categoryDialog.deleteInProgress': 'Kategorie wird gelöscht',
  'categoryDialog.deleteSuccess': 'Kategorie erfolgreich gelöscht',

  'categoryMoveDialog.successMoveMessage': 'Verschiebung erfolgreich',
  'categoryMoveDialog.InProgressMoveMessage': 'Verschiebung läuft',
  'categoryMoveDialog.successCopyMessage': 'Kopieren erfolgreich',
  'categoryMoveDialog.InProgressCopyMessage': 'Kopiervorgang läuft',
  'categoryMoveDialog.moveHeader': 'Kategorie verschieben',
  'categoryMoveDialog.moveSubtext':
    'Neues übergeordnetes Element für "{categoryName}" auswählen.',
  'categoryMoveDialog.cancelButton': 'Abbrechen',
  'categoryMoveDialog.moveButton': 'Verschieben',

  'messageDialog.dismissAllButton': 'Beenden',

  'metaAttach.attachButton': 'Metadaten an ausgewählte Elemente anhängen',
  'metaAttach.replaceCheckbox': 'Metadaten ersetzen',
  'metaAttach.defaultAttachBehavior': 'Standard: an Metadaten anhängen',
  'metaAttach.attachArea':
    'Elemente einfach hier ablegen, um Metadaten anzuhängen\n\n\nOder',
  'metaAttach.umosExpectedError': 'Erwartete UMOs wurden gefunden',
  'metaAttach.genericPartialError':
    'Beim Anhängen der Metadaten sind ein oder mehrere Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'metaAttach.currentValues': 'Aktuelle Daten',
  'metaAttach.editCurValues': 'Metawerte bearbeiten',
  'metaAttach.PopulateButton': 'Ausfüllen',
  'metaAttach.RelationshipDesc': 'Beschreibung',
  'metaAttach.metaPopulateDragDrop':
    'Hinzufügen der ausgewählten Element-IDs zum Metatag "{tagName}" durch\n\nZiehen der Elemente hierher\n\nODER',
  'metaAttach.populateMetatagDoesntExist':
    'Ein Metatag vom Typ „UMO Insert Group“ konnte nicht gefunden werden.',
  'metaAttach.metaCopyDragDrop':
    'Metadaten von {umoName} in die ausgewählten Elemente kopieren, durch\n\nZiehen der Elemente hierhern\n\nODER',
  'metaPanel.title': 'Metadaten:',

  'navOptions.setsHeader': 'HÖHEPUNKTE',
  'navOptions.workspaceHeader': 'ARBEITSBEREICHE',
  'navOptions.categoryHeader': 'KATEGORIEN',
  'navOptions.adminHeader': 'ADMINISTRATOR',
  'navOptions.homeHeader': 'STARTSEITE',
  'navOptions.formsHeader': 'FORMULARE',
  'navOptions.thesaurusHeader': 'THESAURUS',
  'navOptions.reportsHeader': 'REPORTS',

  'navAdminPanel.metaAttach': 'Metadaten anhängen',
  'navAdminPanel.manageUsers': 'Benutzer verwalten',
  'navAdminPanel.usersAndRoles': 'Benutzer und Rollen',
  'navAdminPanel.adminHeader': 'Administrator',
  'navAdminPanel.manageCategoryRoles': 'Kategorie-Rollen Manager',
  'navAdminPanel.publishBtn': 'Medien veröffentlichen',
  'navAdminPanel.createRelationalBtn': 'Neuen Datensatz hinzufügen',
  'navAdminPanel.manageLoader': 'Loader verwalten',

  'navReportsPanel.editHistory': 'Historie bearbeiten',
  'navReportsPanel.RecordHeader': 'Berichte',
  'navReportsPanel.umoID': 'UMO ID',
  'navReportsPanel.categoryID': 'Kategorie ID',
  'navReportsPanel.date': 'Datum',
  'navReportsPanel.user': 'Benutzer',
  'navReportsPanel.tagName': 'Tag-Name',
  'navReportsPanel.change': 'Ändern',
  'navReportsPanel.submit': 'Senden',
  'navReportsPanel.downloadCSV': 'CSV herunterladen',
  'navReportsPanel.dateFrom': 'Datum von',
  'navReportsPanel.dateTo': 'Datum bis',
  'navReportsPanel.enterUMOID': 'UMO ID eingeben',
  'navReportsPanel.downloadList': 'Liste herunterladen',
  'navReportsPanel.type': 'Typ',
  'navReportsPanel.filename': 'Dateiname',

  'adminPublish.publishTitle': 'Medien veröffentlichen',
  'adminPublish.publishBtn': 'STARTEN',
  'adminPublish.publishBtnTitle':
    'Sind Sie sicher, dass Sie den Synchronisierungsprozess starten möchten?',
  'adminPublish.publishBtnStart': 'Synchronisierung einleiten',
  'adminPublish.publishBtnCancel': 'Abbrechen',
  'adminPublish.publishProc.Success':
    'Synchronisationsprozess erfolgreich gestartet',
  'adminPublish.publishProc.Fail':
    'Beim Übertragen von Medien an das Portal ist ein Fehler aufgetreten',
  'adminPublish.publishProc.EmptyQueue':
    'Nichts in der Warteschlange. Alle Assets sind bereits veröffentlicht',
  'adminPublish.publishSubTitle':
    'Dies veröffentlicht alle entsprechend markierten Assets im Portal',

  'navCategoryPanel.workspaceToCategoryError':
    'Sie können keine Arbeitsbereich-Elemente in eine Kategorie verschieben',
  'navCategoryPanel.noEditRoleError':
    'Sie haben nicht die Berechtigung, Objekte in diese Kategorie zu verschieben oder zu kopieren',
  'navCategoryPanel.noMoveRoleError':
    'Sie haben nicht die Berechtigung, Objekte aus der aktuellen Kategorie zu verschieben',
  'navCategoryPanel.categoryHeader': 'Kategorien',
  'navCategoryPanel.createGlobalCategoryBtn': 'Add Global Category',
  'navCategoryPanel.addCategoryButton': 'Kategorie hinzufügen',
  'navCategoryPanel.menuAddChild': 'Unterkategorie hinzufügen',
  'navCategoryPanel.menuUploadToChild': 'Hochladen',
  'navCategoryPanel.menuBulkEditChild': 'Massenaktualisierung',
  'navCategoryPanel.menuEditChild': 'Bearbeiten',
  'navCategoryPanel.menuMoveChild': 'Verschieben',
  'navCategoryPanel.menuSortChild': 'Elemente sortieren',

  'navFormsPanel.formHeader': 'Formulare',

  'navWorkspacePanel.workspaceHeader': 'Arbeitsbereiche',
  'navWorkspacePanel.addWorkspaceButton': 'Arbeitsbereich hinzufügen',
  'navWorkspacePanel.menuAddChild': 'Untergeordnetes Element hinzufügen',
  'navWorkspacePanel.menuEditChild': 'Bearbeiten',

  'navHighlightsPanel.highlightsHeader': 'Schwerpunkte',
  'navHighlightsPanel.addSetButton': 'Schwerpunkt-Set hinzufügen',
  'navHighlightsPanel.menuEditChild': 'Bearbeiten',

  'navThesaurusPanel.thesaurusHeader': 'Thesaurus',
  'navThesaurusPanel.addTermButton': 'Begriff hinzufügen',
  'navThesaurusPanel.menuEditChild': 'Bearbeiten',
  'navThesaurusPanel.attachSuccessful': 'Erfolgreich hinzugefügt',

  'thesaurusDialog.editHeader': 'Begriff bearbeiten',
  'thesaurusDialog.saveButton': 'Speichern',
  'thesaurusDialog.createChildHeader': 'Unterbegriff hinzufügen',
  'thesaurusDialog.createButton': 'Erstellen',
  'thesaurusDialog.addHeader': 'Begriff hinzufügen',
  'thesaurusDialog.namePlaceholder': 'Begriffsnamen eingeben',
  'thesaurusDialog.deleteCheckbox': 'Diesen Begriff löschen',
  'thesaurusDialog.deleteButton': 'Löschen',
  'thesaurusDialog.deleteInProgress': 'Löschvorgang läuft',
  'thesaurusDialog.deleteSuccess': 'Begriff erfolgreich gelöscht',

  'pagination.previousButton': 'Vorherige',
  'pagination.pageNumberOfTotal': 'von {pageTotal}',
  'pagination.nextButton': 'Nächste',

  'panelTree.noItemsMessage': 'Keine Artikel zum Anzeigen',

  'searchBar.defaultSearch': 'Einfache Suche',
  'searchBar.advancedSearch': 'Erweiterte Suche',
  'searchBar.advancedButton': 'Erweiterte Suche',
  'searchBar.advanced.defaultCollectionLabel': 'Metadatengruppe auswählen',
  'searchBar.advanced.selectCollectionPlaceholder': 'Sammlung auswählen',
  'searchBar.advanced.collectionsRetrieveError':
    'Fehler beim Abrufen von Sammlungen; Klicken Sie, um es erneut zu versuchen',
  'searchBar.advanced.mediaType': 'Medientyp auswählen',
  'searchBar.advanced.addMetatagButton': 'Suchfeld hinzufügen',
  'searchBar.advanced.searchButton': 'Suche',
  'searchBar.advanced.clearButton': 'Löschen',
  'searchBar.advancedForm.operatorAnd': 'UND',
  'searchBar.advancedForm.operatorOr': 'ODER',
  'searchBar.advancedForm.operatorNot': 'NICHT',
  'searchBar.advancedForm.anyMetatagOption': 'Beliebiger Meta-Tag Suchfeld',
  'searchBar.advancedForm.searchTermPlaceholder': 'Suchbegriff',
  'searchBar.advanced.newSearchName': 'Neuer Suchname',
  'searchBar.advanced.saveSearch': 'Suche Speichern',
  'searchBar.advanced.savedSearches': 'Gespeicherte Suche',
  'searchBar.advanced.searchNameMissing': 'Suchname fehlt',
  'searchBar.advanced.searchSaveError':
    'Ein Fehler ist aufgetreten beim Versuch, Ihre Suche zu speichern',
  'searchBar.advanced.deleteSearchButton': 'Löschen {searchName}',
  'searchBar.advanced.saveSearchExists': 'Name existiert bereits',
  'searchBar.advanced.specificCollection': 'Nur aktuelle Sammlung durchsuchen',

  'searchBar.simple.searchPlaceholder': 'Suche',
  'searchBar.simple.typeAny': 'Alle',
  'searchBar.simple.typeImage': 'Bild',
  'searchBar.simple.typeVideo': 'Video',
  'searchBar.simple.typeAudio': 'Audio',
  'searchBar.simple.typeDocument': 'Dokument',
  'searchBar.simple.typeRecord': 'Aufnehmen',

  'umoDetailView.requestUMOError': 'Kein UMO zurückgegeben',
  'umoDetailView.primaryImageLabel': 'Dies ist das primäre Bild.',
  'umoDetailView.setAsPrimaryButton':
    'Dieses Bild als primäres Bild festlegen.',
  'umoDetailView.setAsPrimaryWarningMessage':
    'Sind Sie sicher, dass Sie dieses Bild als primäres Bild festlegen möchten?',
  'umoDetailView.addToWorkspaceButton': 'Hinzufügen {workspaceName}',
  'umoDetailView.addToWorkspaceGenericButton': 'Zum Arbeitsbereich hinzufügen',
  'umoDetailView.DownloadImageButton': 'Herunterladen',
  'umoDetailView.DownloadViewedImageTooltip': 'Angezeigtes Bild herunterladen',
  'umoDetailView.metadataHeader': 'Metadaten',
  'umoDetailView.relatedItemHeader': 'Verwandte Artikel:',
  'umoDetailView.loadingModel':
    'Modell wird geladen. Dies kann einige Zeit dauern. Bitte warten.',
  'umoDetailView.renderingModel': 'Modell wird erstellt. Bitte warten.',

  'umoCardView.save': 'Speichern',
  'umoCardView.dueDate': 'Ablaufdatum',
  'umoCardView.status': 'Status',
  'umoCardView.delete': 'Löschen',
  'umoCardView.deleteCard': 'Karte löschen',
  'umoCardView.newComment': 'Neu',
  'umoCardView.edit': 'Bearbeiten',
  'umoCardView.edited': '(Bearbeitet)',
  'umoCardView.cancel': 'Abbrechen',
  'umoCardView.attachments': 'Anhänge',
  'umoCardView.uploading': 'Hochladevorgang läuft',
  'umoCardView.comments': 'Kommentare',
  'umoCardView.description': 'Beschreibung',
  'umoCardView.addComment': 'Neuen Kommentar hinzufügen',
  'umoCardView.noAttachments': 'Es ist noch nichts angehängt',
  'umoCardView.submit': 'Abschicken',
  'umoCardView.uploadButton': 'Hochladen',
  'umoCardView.commentBy': 'Kommentar von {name}, ',
  'umoCardView.getCardError':
    'Beim Abrufen der Kartendaten ist ein Fehler aufgetreten',
  'umoCardView.delCommentError':
    'Beim Versuch, den Kommentar zu löschen, ist ein Fehler aufgetreten',
  'umoCardView.delAttachmentError':
    'Beim Versuch, die Datei zu löschen, ist ein Fehler aufgetreten',
  'umoCardView.delCardError':
    'Beim Versuch, die Karte zu löschen, ist ein Fehler aufgetreten',
  'umoCardView.delCardVerify':
    'Sind Sie sicher, dass Sie diese Karte löschen möchten?',
  'umoCardView.delCommentUndo': 'Kommentar löschen rückgängig machen',
  'umoCardView.delFileUndo': 'Datei löschen rückgängig machen',
  'umoCardView.undo': 'rückgängig machen',
  'umoCardView.uploadFileError':
    'Beim Versuch, die Datei hochzuladen, ist ein Fehler aufgetreten',
  'umoCardView.addCommentError':
    'Beim Versuch, den Kommentar zu speichern, ist ein Fehler aufgetreten',
  'umoCardView.inCategory': 'In {catName}',
  'umoCardView.tabGeneral': 'Allgemein',
  'umoCardView.tabComments': 'Kommentare',
  'umoCardView.tabMetadata': 'Metadaten',
  'umoCardView.updateCardError':
    'Beim Aktualisieren der Karte ist ein Fehler aufgetreten',
  'umoCardView.tabHistory': 'Verwendungshistorie',
  'umoCardView.historyID': 'Vorgang',
  'umoCardView.historyName': 'Name',
  'umoCardView.historyDetails': 'Details',
  'umoCardView.historyDate': 'Datum',
  'umoCardView.historyNone': 'Keine Historie des Assets',

  'umoGridItem.relatedItemTagLabel': 'ähnliche Artikel',
  'umoGridItem.relatedItemTagDescription': 'Gleichrangige Artikel',
  'umoGridItem.alternateItemTagLabel': 'Alternativen',
  'umoGridItem.alternateItemTagDescription': 'Alternative Bilder als Primäres',
  'umoGridItem.addToWorkspaceTooltip': 'Hinzufügen "{workspaceName}"',
  'umoGridItem.selectWorkspaceTooltip': 'Es ist kein Arbeitsbereich ausgewählt',
  'umoGridItem.reportImageTooltip': 'Medien melden',
  'umoGridItem.viewMetaDataTooltip': 'Metadaten anzeigen',
  'umoGridItem.viewDetailsButton': 'Details anzeigen',
  'umoGridItem.menuEditMetaData': 'Metadaten bearbeiten',
  'umoGridItem.menuCrop': 'Zuschneiden',
  'umoGridItem.menuRotate': 'Rotate',
  'umoGridItem.menuMirror': 'Mirror',
  'umoGridItem.menuImageAnnotator': 'Bild Annotator',
  'umoGridItem.menuResize': 'Größe ändern',
  'umoGridItem.menuAudioAnnotator': 'Audio Annotator',
  'umoGridItem.menuVideoAnnotator': 'Video Annotator',
  'umoGridItem.menuVideoSnippet': 'Video-Schnipsel',
  'umoGridItem.menuViewPeers': 'Verwandte Bilder anzeigen',
  'umoGridItem.menuEditMeta': 'Metadaten bearbeiten',
  'umoGridItem.menuMetaPopulate': 'Medien verknüpfen',
  'umoGridItem.menuMetaCopy': 'Metadaten kopieren',
  'umoGridItem.menuNoDownloadsAvailableMessage': 'Keine Downloads verfügbar',
  'umoGridItem.toolsHeader': 'Werkzeuge',
  'umoGridItem.menuDownloadsHeader': 'Downloads',
  'umoGridItem.menuRelatedImagesHeader': 'Verwandte Bilder',
  'umoGridItem.menuToolsHeader': 'Werkzeuge',
  'umoGridItem.cropUnsupportedTypes':
    'Zuschneiden für Dateitypen .dng/.cr2/.nef/.raw wird nicht unterstützt',
  'umoGridItem.rotateUnsupportedTypes':
    'Rotation wird nicht unterstützt für .dng/.cr2/.nef/.raw',
  'umoGridItem.mirrorUnsupportedTypes':
    'Spiegelung wird nicht unterstützt für .dng/.cr2/.nef/.raw',
  'umoGridItem.noDerivativeAccess':
    'Keine Derivate für dieses Bild verfügbar',
  'umoGridItem.menuSimilarColor': 'Similar Colored Images',
  'umoGridItem.menuImageMatch': 'Matching Images',
  'umoGridItem.menuGglLandmark': 'Landmarks Recognition',
  'umoGridItem.menuGglLabels': 'Labels Recognition',
  'umoGridItem.menuGglReverse': 'Reverse Image Recognition',
  'umoGridItem.menuGglHandwriting': 'Handwriting Recognition',
  'umoGridItem.menuGglText': 'Text Recognition',
  'umoGridItem.menuAmznFacial': 'Facial Recognition',

  'umoListItem.fileName': 'Dateiname',
  'umoListItem.type': 'Typ',
  'umoListItem.size': 'Größe',
  'umoListItem.height': 'Höhe (px)',
  'umoListItem.width': 'Breite (px)',
  'umoListItem.duration': 'Dauer',
  'umoListItem.dateCreated': 'Datum erstellt',

  'workspace.dropRestrictionError':
    'Sie können keine Objekte zwischen Arbeitsbereichen verschieben. Nur von einer Kategorie in einen Arbeitsbereich oder in ein anderes Verzeichnis innerhalb desselben Arbeitsbereichs',

  'workspaceDialog.editWorkspaceHeader': 'Arbeitsbereich bearbeiten',
  'workspaceDialog.attachments': 'Anhänge',
  'workspaceDialog.saveButton': 'Speichern',
  'workspaceDialog.addChildWorkspaceHeader':
    'Untergeordneten Arbeitsbereich hinzufügen',
  'workspaceDialog.createButton': 'Erstellen',
  'workspaceDialog.addWorkspaceHeader': 'Arbeitsbereich hinzufügen',
  'workspaceDialog.shareLabel': 'Teilen',
  'workspaceDialog.sharePlaceholder':
    'Benutzer auswählen, mit denen Sie Ihren Arbeitsbereich teilen möchten',
  'workspaceDialog.shareRemoveAll': 'Alle entfernen',
  'workspaceDialog.nameLabel': 'Name',
  'workspaceDialog.namePlaceholder': 'Name des Arbeitsbereichs eingeben',
  'workspaceDialog.descriptionLabel': 'Beschreibung',
  'workspaceDialog.descriptionPlaceholder':
    'Beschreibung des Arbeitsbereichs eingeben',
  'workspaceDialog.expiryLabel': 'Ablaufdatum:',
  'workspaceDialog.sharingSecurityLabel': 'Sicherheit der Freigabe:',
  'workspaceDialog.sharingSecurityCheckbox': 'Öffentlich | Sicher',
  'workspaceDialog.sharingSecurityHelper':
    'Im öffentlichen Modus können alle Assets im Arbeitsbereich angezeigt werden.\n\nIm sicheren Modus können Benutzer nur die Assets anzeigen, auf die sie bereits Zugriff haben.',
  'workspaceDialog.ownerLabel': 'Arbeitsbereich erstellt von:',
  'workspaceDialog.deleteButton': 'Löschen',
  'workspaceDialog.cancelButton': 'Abbrechen',
  'workspaceDialog.deleteWorkspace':
    'Wenn Sie diesen Arbeitsbereich löschen, werden auch alle untergeordneten Arbeitsbereiche gelöscht. Dieser Vorgang kann einige Augenblicke dauern.',
  'workspaceDialog.deleteSuccess': 'Arbeitsbereich erfolgreich gelöscht',
  'workspaceDialog.unsubscribeButton': 'Abmelden',
  'workspaceDialog.unsubscribeFromWS':
    'Wollen Sie sich wirklich von diesem Arbeitsbereich abmelden?',
  'workspaceDialog.unsubscribeSuccess':
    'Sie haben sich erfolgreich von diesem Arbeitsbereich abgemeldet.',
  'workspaceDialog.nameExists':
    'Ein Arbeitsbereich mit demselben Namen existiert bereits',
  'workspaceDialog.errorOccurred':
    'Beim Speichern Ihres Arbeitsbereichs ist ein Fehler aufgetreten',
  'workspaceDialog.downloadRuleList': 'Download-Regel für externe Benutzer:',
  'workspaceDialog.downloadRuleListHelper':
    'Wählen Sie eine Download-Regel aus, die für Portalbenutzer gelten soll.',
  'workspaceDialog.downloadRuleListEmpty':
    'Keine externen Downloadregeln anzeigen',
  'workspaceDialog.downloadRuleSetting': 'Download-Einstellungen:',
  'workspaceDialog.downloadRuleSettingHelper':
    'Wenden Sie sich an den Besitzer des Arbeitsbereichs, um die verfügbaren Download-Regeln zu ändern.',

  'mainDialog.title': 'Links teilen',
  'mainDialog.subTitle': 'Medienelement {umoName} freigeben',
  'mainDialog.copy': 'Kopiert',
  'mainDialog.copyTooltip': 'In die Zwischenablage kopieren',

  'highlightSetDialog.editWorkspaceHeader': 'Schwerpunkt-Set bearbeiten',
  'highlightSetDialog.addWorkspaceHeader': 'Schwerpunkt-Set hinzufügen',
  'highlightSetDialog.namePlaceholder': 'Set-Namen eingeben',
  'highlightSetDialog.deleteSuccess': 'Set erfolgreich gelöscht',
  'highlightSetDialog.nameExists':
    'Ein Set mit demselben Namen existiert bereits',
  'highlightSetDialog.errorOccurred':
    'Beim Speichern Ihres Sets ist ein Fehler aufgetreten',

  'workspaceEmailDialog.emailSentSuccessMessage': 'E-Mail erfolgreich gesendet',
  'workspaceEmailDialog.emailWorkspaceHeader':
    'Arbeitsbereich per E-Mail versenden',
  'workspaceEmailDialog.emailWorkspaceSubtext':
    'Verwenden Sie dieses Formular, um den Inhalt dieses Arbeitsbereichs per E-Mail zu versenden.',
  'workspaceEmailDialog.emailWorkspacePortal':
    'Verwenden Sie dieses Formular, um ein temporäres Konto mit Zugang zu diesem Arbeitsbereich zu erstellen.',
  'workspaceEmailDialog.namePlaceholder': 'Ihr Name',
  'workspaceEmailDialog.accountNamePlaceholder': 'Account Name',
  'workspaceEmailDialog.toEmailPlaceholder': 'An E-Mail Adresse',
  'workspaceEmailDialog.toEmailSubtext':
    'Verwenden Sie ein Komma oder Semikolon, um mehrere E-Mails zu trennen.',
  'workspaceEmailDialog.messagePlaceholder': 'Nachricht',
  'workspaceEmailDialog.cancelButton': 'Abbrechen',
  'workspaceEmailDialog.sendButton': 'Senden',
  'workspaceEmailDialog.DMZMessage':
    'Es kann einige Minuten dauern, bis alle Elemente im DMZ-Arbeitsbereich angezeigt werden',

  'workspaceResizeDialog.mainTitle': 'Bildgröße ändern',
  'workspaceResizeDialog.optionsTitle': 'Größenanpassungs-Optionen',
  'workspaceResizeDialog.optionsType': 'Typ',
  'workspaceResizeDialog.optionsWidth': 'Breite',
  'workspaceResizeDialog.optionsDPI': 'DPI',
  'workspaceResizeDialog.optionsQuality': 'Qualität',
  'workspaceResizeDialog.optionsEmbedMetadata': 'XMP-Metadaten einbetten',
  'umoModifyDialog.buttonCancel': 'Abbrechen',
  'umoModifyDialog.buttonApply': 'Anwenden',
  'umoModifyDialog.tabResize': 'Größe ändern',
  'umoModifyDialog.tabCrop': 'Zuschneiden',
  'umoModifyDialog.tabCopy': 'Kopieren',
  'umoModifyDialog.tabRotate': 'Drehen',
  'umoModifyDialog.inProgressMessage':
    'Dieser Vorgang kann einige Zeit in Anspruch nehmen und wird im Hintergrund fortgesetzt.',
  'workspaceDownloadDialog.buttonDownload': 'Herunterladen',
  'workspaceDownloadDialog.autoEmailDownload':
    'This item is being generated in the background and will be sent to your email address',
  'workspaceDownloadDialog.emailDownload':
    'Dieses Element wird an die angegebene E-Mail-Adresse gesendet',
  'workspaceDownloadDialog.emailDynamicDownload':
    'Dieses Element wird dynamisch generiert und an die angegebene E-Mail-Adresse gesendet',
  'workspaceDownloadDialog.mainTitle': 'Medien herunterladen',
  'workspaceDownloadDialog.optionsTitle':
    'Inhalt des Arbeitsbereichs als ZIP-Datei herunterladen',
  'workspaceDownloadDialog.pdfDownloadTitle':
    'PDF-Datei mit dem Inhalt des Arbeitsbereichs erzeugen',
  'workspaceDownloadDialog.optionsSubTitle':
    'Ableitung für jeden Medientyp auswählen',
  'workspaceDownloadDialog.optionsPhoto': 'Foto',
  'workspaceDownloadDialog.optionsVideo': 'Video',
  'workspaceDownloadDialog.optionsAudio': 'Audio',
  'workspaceDownloadDialog.optionsDocuments': 'Dokumente',
  'workspaceDownloadDialog.optionsItemsPerPage':
    'Wählen Sie die Anzahl der Elemente pro Seite.',

  'workspacePreview.workspaceDetailsButton': 'Arbeitsbereich Details',
  'workspacePreview.options': 'Optionen',
  'workspacePreview.selection': 'Auswahl',
  'workspacePreview.selection.selectAll': 'Alles auswählen',
  'workspacePreview.selection.deselectAll': 'Alles abwählen',
  'workspacePreview.actions': 'Aktionen',
  'workspacePreview.actions.removeSelectedFromWorkspace':
    'Auswahl im Arbeitsbereich entfernen',

  'utils.piction.moveCategoryGenericError':
    'Ein unbekannter Fehler ist aufgetreten, bitte versuchen Sie es erneut.',
  'utils.piction.moveCategoryPermissionError':
    'Sie haben nicht die Berechtigung, Objekte in die ausgewählte Kategorie zu verschieben',

  'metadataView.noMetadata':
    'Es sind keine Metadaten für das ausgewählte umo verfügbar',

  'newRelational.addNewRelational': 'Neuen Datensatz hinzufügen',
  'newRelational.configErr': 'Konfigurationsfehler.',
  'newRelational.contactAdminMsg':
    'Wenden Sie sich an Ihren Systemadministrator, um diese Funktion zu nutzen',
  'highlight.curated.sets': 'Zusammengestellte Sets',

  'fileUploader.title': 'Piction Datiupload',
  'fileUploader.subTitle':
    'Mehrere Dateien hochladbar. Dateien per Drag & drop ablegen.',
  'fileUploader.uploadToCategoryLabel': 'Upload in Bereich: ',
  'fileUploader.dropAreaLabel': 'Hier ablegen',
  'fileUploader.browseOrDropLabel':
    'Klicken für Dateiauswahl oder Datei hier ablegen',
  'fileUploader.addMoreLabel': 'Weitere hinzufügen',
  'fileUploader.addMetadata': 'Metadaten hinzufügen',
  'fileUploader.fileList': 'File List',
  'fileUploader.itemsSelected': ' ausgewählt',
  'fileUploader.loadingLabel': 'Laden',
  'fileUploader.uploadingLabel': 'Hochladen',
  'fileUploader.processingLabel': 'Dateien verarbeiten',
  'fileUploader.waitLabel': ', Bitte warten',
  'fileUploader.fileUploadFail': 'Datei kann nicht hochgeladen werden',
  'fileUploader.fileUploadFailFor': 'Hochladen von {filename} fehlgeschlagen',
  'fileUploader.fileUploadSuccess': ' upload erfolgreich',
  'fileUploader.fileUploadPause': 'Upload für {filename} gestoppt/angehalten',
  'fileUploader.nameExists':
    'Hochladen fehlgeschlagen. Datei mit Namen {name} existiert bereits',
  'fileUploader.maxFilesExceeded':
    'Sie haben die maximal zulässige Anzahl an Dateien überschritten. Sie können nur bis zu {maxCount} Dateien hochladen.',
  'fileUploader.maxTotalFileSize':
    'Maximale Gesamtdateigröße von {size} überschritten, bitte entfernen Sie einige Dateien',
  'fileUploader.maxFilesize': 'Maximale Dateigröße',
  'fileUploader.invalidType': 'Die Datei {fileName} hat einen ungültigen Typ',
  'fileUploader.supportedFileTypes': 'Whitelisting: ',
  'fileUploader.copyRowDown': 'Ungültiger Dateityp',
  'fileUploader.copyRowUp': 'Kopiere diese Zeile nach oben',
  'fileUploader.copyRowToRows': 'Kopiere diese Zeile in eine andere Zeile',
  'fileUploader.copyCellDown': 'Kopiere diese Zelle nach unten',
  'fileUploader.copyCellUp': 'Kopiere diese Zelle nach oben',
  'fileUploader.copyCellToCell': 'Kopiere diese Zelle in eine andere Zelle',
  'fileUploader.metaUpdateSuccess': 'Metadaten erfolgreich aktualisiert',
  'fileUploader.metaUpdateFail':
    'Aktualisierung der Metadaten ist fehlgeschlagen',
  'fileUploader.uploadInProgressMessage':
    'Upload in progress. Try again later.',

  'fileLoadingIndicator.uploads': 'Uploads',
  'fileLoadingIndicator.uploadComplete': 'Upload abgeschlossen',
  'fileLoadingIndicator.uploading': 'Upload läuft',
  'fileLoadingIndicator.pleaseWait':
    'Bitte warten, der Vorgang kann einige Zeit dauern.',
  'fileLoadingIndicator.pleaseReview':
    'Bitte nehmen Sie sich die Zeit, alle hochgeladenen Dateien noch einmal zu überprüfen.',
  'fileLoadingIndicator.filterAll': 'All',
  'fileLoadingIndicator.filterQueued': 'In der Queue',
  'fileLoadingIndicator.filterUploading': 'Upload läuft',
  'fileLoadingIndicator.filterUploaded': 'Hochgeladen',
  'fileLoadingIndicator.filterFailed': 'Fehlgeschlagen',
  'fileLoadingIndicator.filterDuplicated': 'Dupliziert',
  'fileLoadingIndicator.noFilesFound':
    'Keine Dateien für den verwendeten Filter gefunden.',
  'metaInput.newEntry': 'Neuer Eintrag',
  'metaInput.addNewEntry': 'Neuen Eintrag hinzufügen',
  'metaInput.addNewRGroupEntry': 'Neuen Eintrag zu {name} hinzufügen',
  'metaInput.existingEntries': 'Vorhandene Einträge',
  'metaInput.editField': 'Bearbeiten',
  'metaInput.entryNum': 'Eintrag #{number}',
  'metaInput.updateIndividually': 'Einzeln aktualisieren',
  'metaInput.bulkUpdate': 'Massenaktualisierung',

  'imageEdit.rotateImage': 'Bild-Rotation',
  'imageEdit.mirrorImage': 'Bild spiegeln',
};
